import React from "react";
import PropTypes from "prop-types";
import TimeAgo from "react-timeago";
import Authors from "../../atoms/authors";
import { dateFormatterWithoutTime } from "../../../utils";
import "./author-with-time.m.css";

const AuthorWithTime = ({ story = {}, hideAuthor = false, hideTime = false, color = "" }) => {
  return (
    <div styleName="author-wrapper" className="author-wrapper">
      {!hideAuthor && <Authors story={story} authorColor={color} />}
      {!hideTime && (
        <TimeAgo styleName="time-ago" formatter={dateFormatterWithoutTime} className="time-ago" date={story["last-published-at"]} live={false} />
      )}
    </div>
  );
};


AuthorWithTime.propTypes = {
  story: PropTypes.object,
  hideAuthor: PropTypes.bool,
  hideTime: PropTypes.bool,
  color: PropTypes.string
};

export default AuthorWithTime;
